export default __webpack_public_path__ + "static/media/researchLP.4168c73c.png";